import { inject, Injectable } from '@angular/core';
import { DriftsMeddelelserHistorikDatasource } from './driftsmeddelelser-historik.datasource';

@Injectable({
  providedIn: 'root',
})
export class DriftsMeddelelserHistorikService {
  datasource = inject(DriftsMeddelelserHistorikDatasource);
}
